const company = process.env.REACT_APP_TITLE || 'LeCab';

export default {
    admin: {
        owner: 'Owner',
        import: 'Import',
        adminOf: 'Administrator of',
        groupAdmin: 'You are the administrator',
        payment: {
            paymentTitle: 'Means of payment',
            policiesTitle: 'Payment policies',
            policyLabel: 'Payment policy',
            paymentMethodsDesc: `You can add the means of payment used for reservations for your employees.`,
            blueCardTitle: 'Credit cards',
            airplusTitle: 'AirPlus card payment',
            wireTransfer: 'Wire transfer payment',
            onBoardPayment: 'On board payment',
            sepa: 'SEPA payment',
            noBlueCard: "You don't have any credit cards associated",
            noAirplusCard: "You don't have any AirPlus cards associated",
            howToAddSepaAirplus:
                'To add an AirPlus or SEPA Payment card, please contact our customer service. You can also opt for the method of payment by transfer via the RIB present on your monthly invoices.',
            defaultPaymentPerGroup: 'Default payment method for rides',
            configureDefaultPaymentPerGroup: 'Configure your default payment methods for each of your groups.',
            centralized: 'Centralized',
            individual: 'Individual',
            partial: 'Partial payment - with remaining charge',
            monthly: 'Monthly',
            unitary: 'Per ride',
            groupPaymentPolicyTitle: 'Group payment policy',
            groupPaymentPolicyDesc: `You can modify the payment policy of your group via the "Payment" section of the administrator menu.`,
            subtitle: "Personalize your employees' payment options.",
            frequencyPayment: 'Payment frequency',
            paymentCoworkerError:
                "The passenger has no payment method registered in his profile, you can't order a ride for this group.",
            paymentGroupError: 'No payment method is defined for this group. Contact your administrator.',
            voucher: {
                title: 'Coverages',
                description:
                    'Create your partial coverage types here, and associate them with your groups in the “Payment policies” tab',
                empty: 'No coverage on this payment method.',
                add: 'Add a coverage type',
                edit: 'Edit the coverage type',
                deleteHint: 'Are you sure you want to delete the coverage: {{details}} ?',
                form: {
                    name: 'Name',
                    amount: 'Amount',
                    format: 'Format',
                    amountUnit: '€',
                    percentageUnit: '%',
                    duplicateName: 'A coverage already uses this name.',
                    invalidAmount: 'The amount must be greater than 0.',
                    invalidPercentage: 'The percentage must be between 1 and 100.',
                },
                select: {
                    label: 'Coverage',
                    option: '{{name}} — {{value}}',
                    empty: 'No coverage available yet, create one.',
                    emptyAskContractAdmin: 'No coverage available. Contact the contract administrator.',
                },
                errors: {
                    inUse: 'This coverage is used by the payment policy of a group. Remove it from the group before deleting it.',
                },
            },
        },
        roles: {
            booker: 'Book',
            rider: 'Ride',
            principal: 'Administrator',
            title: 'roles',
        },
        importBulk: {
            title: 'Import collaborators',
            descFirstPart: 'Add many collaborators at once by importing a spreadsheet. To start, ',
            descFirstPartCta: ' Download and fill the file.',
            descSecondPartInvite:
                'They will receive an invitation to join this group. You will then be able to change their role within this group.',
            descSecondPart: 'You will then be able to change their role within this group.',
            descThirdPartFirstLine: 'CSV, XLSX accepted',
            descThirdPartSecondLine: 'Column format : lastname, firstname, email, phone number (optional)',
        },
        users: {
            associate: 'Add',
            nbCollabAssociatedSingular: 'collaborator is in this group.',
            nbCollabAssociatedPlural: 'collaborators are in this group.',
            addCollab: 'Add a collaborator',
            inviteCollab: 'Invite a collaborator',
            addCollabDesc: 'Select the group that your new collaborators will be added in.',
            addNewCollab: 'Add a new collaborator',
            inviteNewCollab: 'Invite a new collaborator',
            handleCollab: 'Manage collaborators',
            handleCollabVariant: 'Manage collaborators',
            bulkActionDesc: 'Bulk Action (Role + Ungroup)',
            fillFormCollab: 'Fill the form to add a new collaborator',
            fillFormCollabInvite: 'Fill the form to invite a new collaborator',
            addMultipleCollab: 'Add multiple new collaborators',
            inviteMultipleCollab: 'Invite multiple new collaborators',
            importCollabWithSheet: 'Add employees by importing a spreadsheet.',
            importCollabWithSheetInvite: 'Invite employees by importing a spreadsheet.',
            linkCollab: 'Link existings collaborators',
            selectCollab: 'Select collaborators to add to this group',
            addCollabs: 'Add collaborators',
            ungroup: 'Delete',
            invitePending: 'Pending invitation',
            invitePendingSince:
                'The collaborator was added the {{date}} but still does not seem to have accepted his invitation by email.',
            invitePendingResend: 'Send the invitation again by email.',
            inviteSent: 'Invitation sent',
            editCollab: 'Modify a collaborator',
            collabGroups: 'Group of the collaborator',
            collabGroupsDesc: 'You can import a file containing the collaborators to add to the group.',
            collabGroupsDescInvite: 'You can import a file containing the collaborators to invite to the group.',
            collabLinkGroup: 'Add to a new group',
            collabUnlinkGroup: 'Delete',
            collabUnlinkLastGroup:
                'Are you sure you want to unlink this employee? He belongs only to this group and will therefore be removed from your collaborators if you delete him from his last group.',
            collabUnlinkGroupDesc: 'Are you sure you want to delete this group\'s collaborator "{{group}}"?',
            deleteCollab: 'Delete the employee',
            collabAdded: 'Collaborator added',
            collabDeleted: 'Collaborator deleted',
            deletePopupDesc:
                'Are you sure you want to delete the collaborator "{{user}}"? This action is irreversible.',
            deleteCollabDesc:
                "You can delete your company's collaborator. He will be deleted from all the groups to which it belongs and will no longer be visible in the list of your employees.",
            noCollabResult: 'You currently have no collaborator corresponding to your search.',
        },
        groups: {
            group: 'Group',
            groups: 'Groups',
            addGroup: 'Add a group',
            delGroup: 'Delete the group',
            delGroupToast: 'Group deleted.',
            delGroupDesc: 'You can delete this group. The employees added to it will then be deleted.',
            delGroupConfirmation: 'Are you sure you want to delete this group?',
            travelPolicyTitle: 'Travel policy',
            travelPolicyCautionPartOne: 'You can edit the travel policy of this group.',
            travelPolicyCautionPartTwo: 'Warning, It will already be applied for your next reservation',
            addGroupHint: 'You must be administrator of the contract to create a group',
            travelPolicy: 'Travel policy of the group',
            travelPolicyDescriptionFirstPart: 'Set up travel policies to apply to your ',
            travelPolicyDescriptionSecondPart:
                'group in order to personalize the booking and travel experience of your employees.',
            groupName: 'Name of the group',
            editGroupName: 'Edit group name',
            addGroupDescription: 'Name your new group so you can assign new travel policies to it in the next step.',
            editGroup: 'Edit a group',
            editGroupAddCollabTitle: 'Add/edit collaborators',
            editGroupAddExistingCollabDesc: 'Select collaborators to add to your group "{{group}}".',
            editGroupAddCollabDesc: 'Add new collaborators, modify their role(s) or unassociate them.',
            editGroupMessage:
                'You will be able to edit the information of each group, invite collaborators to join them and access their travel policies.',
        },
        billing: {
            formula: {
                title: 'Subscription',
                dueDate: 'Amount due for ',
                currencyPerMonth: '€/month TTC',
                user: 'user',
                maxUsers: 'Max. {{maxUsers}} users',
                unlimited: 'Unlimited',
                additionalUsers: {
                    title: 'Out package',
                    collab: 'collaborator(s)',
                    guest: 'guest(s)',
                },
                changeOffer: {
                    title: 'Change formula',
                    label: 'You can change the formula at any time.',
                },
                chart: {
                    nbUsers: 'Number of users',
                    formula: 'Active offer',
                },
                terminate: 'I wish to terminate my subscription',
            },
            invoices: {
                title: 'Invoices',
                invoices: 'Your invoices',
                downloadReport: 'Download the report',
                description: 'You will find the list of invoices in your groups here.',
                noInvoices: 'You have no invoices issued.',
                noInvoicesResult: 'You have currently no invoices issued corresponding to your search.',
                type: {
                    title: 'Invoice type',
                    ride: 'Ride invoice',
                    month: 'Monthly invoice',
                    subscription: 'Subscription',
                    correction: 'Invoice',
                    exceptional: 'Invoice',
                },
            },
            settings: {
                title: 'Settings',
                address: {
                    title: 'Billing address',
                    name: 'Billing name',
                    address: 'Address',
                    postalCode: 'Postal code',
                    city: 'City',
                    country: 'Country',
                },
                contact: {
                    title: 'Financial contact',
                    description: 'Add one or more financial contact(s). They will receive invoices by email.',
                    add: 'Add financial contact',
                    edit: 'Edit financial contact',
                },
                params: {
                    title: 'Billing parameters',
                    description: 'TODO',
                    commandNumber: 'Purchase order',
                    vta: 'VAT number',
                    xls: 'Invoice XLS',
                    group: 'Invoices per group',
                    termination: 'Termination',
                    terminationDescription:
                        'To terminate your services, please inform us by e-mail at the address resiliation@lecab.fr. We will process your request as soon as possible.',
                },
            },
        },
    },
    addressType: {
        airports: 'Airports',
        airportLabel: 'Airport',
        airportDescription: 'See the nearest airports',
        stations: 'Stations',
        stationLabel: 'Train station',
        stationDescription: 'See the nearest stations',
        favorites: 'Favorites',
        favoritesDescription: 'See your favorites',
    },
    geolocation: {
        current: 'My current position',
        noLocation: 'Authorize us to get your location to gives you better recommandation.',
        noLocationMobile: 'Authorize us to get your location to gives you better recommandation.',
    },
    booking: {
        number: 'Ride number:{{number}}',
        details: 'Details',
        seeDetails: 'See details',
        moreDetails: 'More details',
        passengerInfos: 'Passenger information',
        reservationInfos: 'Reservation information',
        driverInfos: 'Driver information',
        reactiveFlow: 'Click here to continue your reservation',
        soonRides: '{{count}} ride(s) in progress',
        allRides: 'See all rides in progress',
        policiesNoRide: "Can't book",
        limitTime: 'reservation limit reached',
        limitTimeDesc: 'The reservation for {{dayHour}} is not authorized for the group {{group}}. ',
        limitGeo: 'Authorization area limit',
        limitGeoDesc: 'You can only make reservations between the authorization zones defined by your company.',
        contactAdmin: 'For more information, please contact your group administrator.',
        modalCancelAirportTitle: 'Leave',
        modalCancelAirportBody: 'Are you sure you want to leave the airport reservation flow?',
        modalCancelStationBody: 'Are you sure you want to leave the station reservation flow?',
        noPoiOther: 'Skip this step',
        noPoiAirport: 'I am not departing from an airport',
        noPoiStation: 'I am not departing from the train station',
        noPoiBody: 'Your driver will pick you up at the following address: {{address}}',
        checkedBaggage: 'Checked Luggage',
        inPlaneBaggage: 'Carry-on Luggage',
        plannedFlightArrivalDate: 'Your flight is scheduled to arrive on ',
        askingLuggageType: 'What kind of luggage will you have?',
        adviseLuggageTime:
            'In order to pass the various checks and collect your luggage with complete peace of mind, we advise you to schedule the departure of your ride at the following time:',
        askingOrderTime: 'At what time would you like to schedule your ride?',
        cancelResa: 'Cancel my reservation',
        cancelRideConfirm: 'Are you sure you want to cancel your ride? Some cancelation fees may be billed.',
        cancelRideFees: 'Cancelation fees may be billed.',
        cancelRideReason: 'Please specify the reason for your cancellation:',
        cancelRideDone: 'Your ride has been canceled.',
        cancelRideWithCharge: {
            title: 'Following your cancellation',
            description: 'Your driver being already on the way, cancellation fees will be debited to you.',
            info: 'Our regulation team will contact your driver to better understand this situation.',
        },
        noFees: 'You will not be debited.',
        order: 'Order',
        orderRide: 'We order your ride',
        etaHelper: 'In ',
        seats: ' seats',
        seat: ' seat',
        luggages: ' luggages',
        luggage: ' luggage',
        landingTime: 'Landing time',
        euroCurrency: ' €',
        edit: 'Edit',
        send: 'Send',
        valid: 'OK',
        headerSetDestination: 'Where are you going?',
        headerHello: 'Hello ',
        headerHelloResponsive: 'Hello {{name}} 👋',
        currentPosition: 'Current position',
        searchAddress: 'Search an address',
        pickup: 'Pickup',
        dropOff: 'Drop off',
        scheduleBooking: 'Schedule my ride',
        date: 'Date',
        dateTooEarly: 'The date is too early to book a ride needs to be at least {{X}} minutes away from now.',
        dateTooEarlyPlane:
            'The date is too early to book a ride needs to be at least {{X}} minutes away from now and after your flight has landed.',
        dateTooFuture: 'The date must be planned between 30 minutes and 1 year from now.',
        mad: 'Provision',
        madShort: 'Provision',
        madShortDescription: 'For a desired period',
        selectMad: 'Select a provision period for the driver.',
        modifyMad: 'Modify the provision period',
        madDescription: 'You book your driver for <b>{{X}} hour(s)</b>',
        madPeriod: 'Period',
        madFreeRide: 'Free Ride',
        freeRide: 'Free Ride',
        freeRidePrice: 'Calculate at the end of the ride',
        freeRideDescription: 'You book your driver for <b>a free ride</b>',
        manageFavorites: 'Manage your favorites',
        noFavorite: 'You have no favorite.',
        selectService: 'Select your type of voucher',
        rideCapacityMax: ' passenger(s) maximum',
        voucher: {
            label: 'Select the type of voucher',
            select: 'Type of voucher',
            price: {
                covered: 'Covered',
                remaining: 'Remain to be paid',
                total: 'Total amount',
            },
        },
        voucherCoverage: {
            applied: '{{amount}} voucher applied',
        },
        voucherV2: {
            label: 'Enter the voucher amount',
            placeholder: 'Voucher amount',
            hint: 'The rest at the expense will be calculated in the next step',
            confirm: 'Confirm your request',
            price: {
                covered: 'Covered',
                remaining: 'Remain to be paid',
                totalAmout: 'Total amount',
                total: 'Total',
            },
        },
        select: 'Select',
        passengersTitle: 'Who will be the passenger?',
        selectPassengers: 'Your last passengers',
        noPassengers: 'No passenger',
        addProPassenger: 'Create a new guest',
        searchPassengerGeneric: 'Search by name, phone number or email',
        searchPassengerGenericShort: 'Name, phone or email',
        searchPassengerCoworker: 'Search a coworker',
        searchPassengerGuest: 'Search a guest',
        searchPassengerCoworkerOrGuest: 'Search a coworker or a guest',
        searchRecent: 'Your recent research',
        addProPassengerDescription: 'Add the personal information of your guest to reserve a ride',
        phoneHint: 'Enter a mobile phone number to receive ride tracking SMS',
        bookForOther: 'Book for someone else',
        searchInList: 'Search in the list',
        paymentInfo: 'Payment information',
        paymentTitle: 'Your means of payment',
        paymentCentralized:
            'All your costs are managed by your company, which uses <b>centralized payment</b>. You cannot therefore modify your payment methods.',
        paymentRacCoverage:
            'Your company covers part of the price of your rides. The <b>remaining balance</b> will be taken into account at payment time.',
        selectPayment: 'Select payment',
        cardMask: '•••• ',
        cardExpired: 'Card expired',
        cardNone: 'No card',
        planeTitle: 'About your flight',
        planeFailFetchData:
            "Sorry, we couldn't find your real-time flight information. Please ensure that the following information is correct.",
        planeConfirm: 'Can you confirm that all this information is correct?',
        planePlaceholder: 'Flight number',
        planeExemple: '(ex: AF1234)',
        planeNoNumber: 'Continue without flight number',
        planeNoNumberDesc: 'If you want an immediate departure, you can ignore the first two fields.',
        planeTerminal: 'Terminal',
        planeInfo:
            'Fill in your arrival date as well as your flight number in order to take advantage of the automatic time shift of your ride in the event of a delay in your flight.',
        planeDetails: 'Please provide your flight number to be assisted in case of delay or change of flight.',
        planeAdviseFlightNumber:
            'We advise you to enter your flight number to benefit from automatic ride rescheduling in case your flight is delayed.',
        trainTitle: 'About your train',
        trainPlaceholder: 'Train number',
        trainDetails:
            'Please enter your train number so we can help you reschedule your reservation if your train is running late.',
        meetingPoint: 'Meeting point',
        meetingPointEdit: 'Modify your meeting point',
        meetingPointName: 'Meeting point',
        meetingPointRecap: 'Your meeting point',
        meetingPointDetails: 'Select the most suitable meeting point for your driver.',
        stationDetails: 'Add your train number to facilitate the meeting with your driver',
        nameboard: {
            title: 'Facilitate your arrival',
            label: 'Enjoy a personalized welcome',
            hint1: 'Your driver welcomes you personally, as soon as you arrive.',
            hint2: 'No waiting, no doubt: your driver is there for you.',
            driver: 'Easily find your driver',
        },
        pancarte: 'Personalized support',
        pancartePlane:
            'Do you want to take advantage of personalized support? Your driver will pick you up with a sign in your name.',
        pancarteOn: 'Enable personalized support',
        pancarteOff: 'Disable',
        pancarteRdv:
            'Your driver will await you at the luggage exit from your arrival terminal with a sign in your name.',
        rideReason: 'Add a ride reason',
        rideReasonTitle: 'Ride reason',
        rideReasonDetailsNotMandatory: 'You can add a reason to your ride for each of your reservations :',
        rideReasonDetailsMandatory:
            'Your company needs a ride reason for your reservation. Please explain the reason of your reservation :',
        driverMessageDesc: 'Do you have any additional information to leave with your driver regarding your booking?',
        msgToDriver: 'Add a message for your driver',
        msgToDriverTitle: 'Message for your driver',
        msgToDriverShort: 'Message for driver',
        msgToDriverAuto: 'Always use this message for the driver with this passenger',
        prefilledMessages: {
            gateCode: 'The gate code is',
            wearing: 'I am wearing',
            atTheCornerOf: 'I will be at the corner of',
            inFrontOf: 'I will be in front of',
            doorNumber: 'The door number is',
            nextTo: 'I will be next to',
        },
        recurrence: {
            radio: 'Define recurrence for this ride',
            repeat: 'Repeat on:',
            title: 'Define recurrence',
            ride: 'Recurring ride',
            subtitle: 'Day (s) of recurrence',
            details:
                'Your reservations will take place every Monday, Tuesday ... they will be created 7 days before the start of the next one.',
        },
        priceDetail: 'Price details',
        tripDetail: 'Trip details',
        msgHeader: 'Message for the driver',
        rideNote: 'Ride reason',
        addMsg: 'Add this message to driver',
        whoIsTraveling: 'Who is traveling?',
        whenAreYouLeaving: 'When are you leaving?',
        chooseFastHour: 'Choose in how many minutes you would like to ride with us:',
        planTrip: "Choose the date and time of your driver's arrival at your pick-up location:",
        chooseDateAndHour: 'Choose a date and hour',
        startFrom: 'Start',
        arriveAt: 'Arrival',
        estimatedTime: {
            title: 'Choose the desired date and time of arrival at your destination:',
            selectDO: 'Select a destination',
            missingPUDO: 'You must enter a pickup and a drop off place so that we can estimate the time of your trip.',
            duration: 'Estimated trip time for your ride: <b>{{time}}</b>',
            startDate: 'Estimated departure time: {{time}}',
            hint: 'Real traffic can affect your removal time. To avoid any risk, please provide a margin.',
            error: 'In order to arrive at this hour you should have already left. Please adjust your desired arrival time.',
        },
        status: {
            not_available: 'Not available',
            no_update: 'It is not possible to update this ride',
            service_closed: 'Service closed',
            no_driver_available: 'No driver available',
            too_far_away: 'Too far away',
            region_not_served: 'Region not served',
            rider_restricted: 'Rider restricted',
            insufficient_delay: 'Can only be booked {{X}}h before the departure',
            no_pricing_for_area: 'No pricing for area',
            prebook_not_allowed: 'Prebook not allowed',
            asap_not_allowed: 'Asap not allowed',
            no_pricing: 'No pricing available',
            all_driver_busy: 'Sorry, all our drivers are busy. We encourage you to retry.',
            duplicate_ride: 'You already have an identical booking for this trip.',
        },
        dispatchGroup: {
            sncfpap: 'Reliable and affordable',
            normal: 'Premium speed and comfort',
            exec: 'Our best drivers and vehicles',
            van: 'Comfort for 6 people',
            access: 'Has a ramp, for people with reduced mobility',
        },
        driver: {
            name: 'Your driver is',
            pu: 'Go to your meeting point',
        },
        green: {
            title: 'Congratulations',
            details: 'You have chosen a low CO2 vehicle.',
        },
        toast: {
            created: 'Your ride has been successfully created.',
            createdRecurrence: 'Your recurrence has been successfully created.',
            updated: 'Your ride has been successfully updated.',
            canceledRecurrence: 'Your recurrence has been canceled.',
            cancelError: 'Your ride could not be canceled. Please try again.',
            cancelRecurrentError: 'Your recurrence could not be canceled. Please try again.',
        },
        nextStepBooking: 'Next step',
        confirmBooking: 'Confirm Booking',
        confirmedBooking: 'Booking confirmed',
        confirmedReservation: 'Reservation confirmed',
        confirmedRecurrence: 'Recurrence confirmed',
        consultAndFollowBooking: 'Consult and follow your booking',
        consultBooking: 'Consult your booking',
        consultRecurrence: 'Consult your recurrence',
        bookReturnTrip: 'Book the back trip',
        addToCalendar: 'Add to calendar',
        newBooking: 'New reservation',
        yourTrip: 'Your trip',
        creationDate: 'Creation date',
        driverArrival: 'Arrival of the driver',
        bookNewRide: 'Book a new ride',
        shareRide: 'Share my ride',
        quoteExpired: 'The price of your ride has expired. Please try again.',
        similarRideFound: 'A similar ride has been found. Do you want to continue anyway?',
    },
    bookingSoon: {
        title: 'Follow your rides in real time!',
        bookingNotStarted: 'Ride not started',
        trip: 'Your ride',
        status: {
            reserved: 'Reserved ride',
            processing: 'Assignment of a driver in progress',
            processingSub: 'Please wait for a few moments',
            noDriver: 'Ride canceled. Our drivers are all busy. Please repeat your request',
            fakeIncoming: 'A driver is at ',
            incoming: 'The driver is approaching',
            incomingEta: 'The driver will be there in ',
            incomingSub: 'Prepare for his arrival',
            driverArrived: 'The driver has arrived',
            driverArrivedTime: 'The driver has arrived. Any additional waiting will be billed, he will wait until ',
            driverArrivedSub: 'He is waiting for you at the meeting point',
            inProgress: 'Ride in progress',
            inProgressEta: 'Ride in progress',
            inProgressSub: 'Arrival planned at ',
            inProgressFallback: 'Enjoy your ride',
            canceled: 'Ride canceled',
            canceledNoCharge: 'Rides canceled no charge',
            finished: 'Ride ended',
        },
        driverBusy: 'Our drivers are very busy. We are trying to find you one as soon as possible.',
        orderNew:
            'You can order another ride and follow the status of this one in the ride tracker on the right of your screen.',
        orderNewLink: 'Order a second ride.',
    },
    header: {
        id: 'ID',
        selfService: 'Preferred Client Status',
        selfServiceContinue: 'Finalize my subscription',
        makeReservation: 'Make a reservation',
        profil: 'Profile',
        lecab: `${company}`,
        company: 'Company',
        admin: 'Administrator',
        support: 'Help',
        bookRide: 'Book a ride',
    },
    drawerMenu: {
        home: 'Home',
        profil: 'Profile',
        reservations: 'Reservations',
        favoritesPlaces: 'Favorites',
        tripHistory: 'History',
        family: 'Guests',
        payment: 'Payment',
        billing: 'Billing',
        promoCode: 'Promo Code',
        support: 'Help',
        onlyForPerso: 'Only in ',
    },
    adminMenu: {
        groups: 'Groups',
        collaborators: 'Collaborators',
        billing: 'Billing',
        params: 'Parameters',
    },
    profile: {
        profile: 'Profile',
        editProfile: 'Edit my profile',
        changePwd: 'Change my password',
        logout: 'Logout',
        logoutMessage: 'Are you sure you want to logout?',
        undress: 'Stop impersonation',
        editInfos: 'Edit my information',
        editInfosShort: 'Information',
        editPassword: 'Edit my password',
        firstname: 'Firstname',
        lastname: 'Name',
        email: 'Email',
        phone: 'Phone',
        emailPro: 'Email-Pro',
        company: 'Company',
        confirmButton: 'Confirm',
        cancelButton: 'Cancel',
        password: 'Password',
        scheduleCourse: 'Schedule',
        scheduleArrival: 'Schedule arrival for',
        scheduleRecurrence: 'Schedule recurrence',
        newPassword: 'New password',
        confirmPassword: 'Confirm your password',
        bookingsInfos: 'Bookings information',
        pickupDefault: 'Pickup default',
        dropOffDefault: 'Drop off default',
        setPickupAddress: 'Set a pickup address',
        setDropOffAddress: 'Set a drop off address',
        costCenter: 'Cost center',
        costCenterNone: 'No cost center',
        costCenterSelect: 'Choose a cost center',
        costCenterMandatory:
            'Your company requires a cost center for each of your reservations. Please select a cost center.',
        vehicleTypeDefault: 'Vehicle by default',
        business: 'Business',
        language: 'Languages',
        languageLabel: 'Language',
        languageDescription: 'Select your display and communication language.',
        dealsTitle: 'LeCab deals',
        dealsDescription: 'Receive personalized offers and information about my rides with LeCab.',
        validatePhone: 'Finish your account activation by validating your phone',
        validateEmail: 'Finish your account activation by validating your email',
        validateEmailAndPhone: 'Finish your account activation by validating both your email and phone number.',
        ctaValidatePhone: 'Send me a validation message',
        ctaValidateEmail: 'Send me an activation email',
        validatePhoneTitle: 'Validate your phone number',
        validatePhoneDesc:
            'Validate your phone number to be able to reach your driver and receive follow up message for your rides.',
        receiveCode: 'Receive my code',
        receiveCodeAlt: 'Receive your code',
        passCode: 'Pass this step for now',
        errorOnPhone: "We can't send a code at this moment. Please verify your phone number and retry later",
        errorOnPasswordLost: 'It is not possible to change your password right now. Please retry later.',
        errorOnRequestingCode: 'We were unable to send you the code at this time. Please retry later.',
        errorOnSendingCode: 'We were unable to perform validation. Please verify your code or retry later.',
        enterCode: 'Enter the 4 digits code received at {{phone}}',
        code: 'Code',
        sendCodeAgain: 'Re-send code',
        validationSuccess: 'Your number has been validated',
        checkMailbox: 'Check your mailbox',
        checkMailboxDescFirstPart: "To reset your password, click on the link we've sent you on your mail : ",
        checkMailboxDescSecondPart: 'If you did not receive it, ',
        checkMailBoxCTA: 'resend the email',
        successResendEmail: "We've sent a new email.",
        editPhone: 'Change my phone number',
        editPhoneShort: 'Phone number',
        addPhone: 'Add a phone number',
        addPhoneDesc: 'Complete your profile with a phone number.',
        phoneNumber: 'Phone number',
        sentCode: 'Code sent',
        datas: 'Data and cache',
        resetCache: 'Delete recent addresses and passengers',
        resetCacheDeleted: 'Recent addresses and passengers deleted',
        privacy: 'Privacy',
        legalInfos: 'Legal information',
        rgpd: 'Consent choices',
        deleteAccount: 'Delete my account',
        deleteAccountMessage: 'Are you sure you want to delete your LeCab account?',
        deleteAccountSuccessMessage:
            'Your LeCab account has been successfully deleted. It will be deactivated within two business days by our team.',
        legale: {
            cgv: 'General conditions of sale ',
            mentions: 'Legal notices',
            confidential: 'Confidentiality policies',
            exportRGPD: 'Export my data',
            exportRGPDDescription: 'Please enter your password to confirm your identity.',
            exportAsked: 'Your request has been taken into account.',
            exportAskedDate: `Request made on {{date}}.`,
            exportAskedDescription: 'You will receive your data by email in the coming days.',
        },
    },
    language: {
        fr: 'French',
        en: 'English',
    },
    appearance: {
        light: 'Light mode',
        dark: 'Dark mode',
    },
    roles: {
        title: 'Roles',
        principal: 'Administrator',
        rider: 'Rider',
        booker: 'Booker',
    },
    userTypes: {
        coworker: 'Coworker',
        guest: 'Guest',
        invite: 'Invite',
    },
    reservation: {
        reservations: 'Reservations',
        reservation: 'Reservation',
        filters: 'Filters',
        number: 'Booking number',
        booking: 'Booking n° ',
        booked: 'Booked by ',
        passenger: 'Passenger ',
        bookReturnRide: 'Book the return ride',
        messageToDriver: 'Message to driver',
        addToCalendar: 'Add to calendar',
        editReservation: 'Edit my reservation (Stops, date and service)',
        sosReservation: 'Report an urgent security problem',
        cancelReservation: 'Cancel my reservation',
        pauseRecurrent: 'Pause recurrence',
        unPauseRecurrent: 'Reactivate',
        cancelPauseRecurrent: 'Cancel the pause',
        cancelRecurrent: 'Cancel recurrence',
        cancelRecurrentConfirm:
            'Please note that the deletion of recurrence does not cancel the reservations already created',
        noReservationsYet: 'You have no booking soon.',
        noReservationsNow: 'You have no ride in progress',
        planNewTrip: 'Plan a ride',
        noReservationsDescription: 'Take your first ride today!',
    },
    recurrence: {
        reservation: {
            paused: 'Your recurrence is in pause until',
            willPause: 'Your recurrence will be paused from ',
        },
        pause: 'Pause',
        paused: 'Paused',
        title: 'How long do you want to pause your recurrence?',
        hint: 'If one or more rides were already scheduled for the current week, you will have to cancel them in your upcoming reservations.',
        creation: 'Each new reservation will be created a week in advance.',
    },
    sos: {
        title: 'Report a security problem',
        action: 'Be called',
        actionUrgence: 'Call 112',
        descriptionLong:
            'If you are currently in a <b>dangerous, urgent and serious situation</b>, click the button below.<br><br>Our teams are <b>prepared</b> and you will <b>call you back immediately</b> in order to understand the situation and finding a risk-free solution.',
        description:
            'In LeCab, your security is our top priority.If you are currently in an uncomfortable situation or if you feel the slightest danger during your trip, we are here to provide you with our assistance.',
        description2:
            'By clicking on the button below, our teams will be immediately informed of your assistance need. During the recall, we will ask you questions to better understand the situation and take the necessary measures to guarantee your safety.',
        sent: 'Request sent',
        info: "Following your request, our teams have been alerted and will remind you of the next moments. In order to take the necessary measures to guarantee your safety, please answer questions from our teams using 'yes' or 'no'.",
        enabled: {
            title: 'Establishing contact in progress',
            description: 'You will receive a call in a few seconds.',
            cancel: 'Cancel my request',
        },
    },
    policies: {
        costCenter: {
            header: 'Cost centers',
            headerDescription: 'No cost center',
            headerDescriptionActive: '{{number}} cost center(s)',
            subtitle: 'Organize and categorize your invoices.',
            any: 'No cost center',
            limit: 'With cost centers',
            title: 'Add cost centers and define their conditions of use.',
            defaultValue: 'Define a default cost center',
            defaultNo: 'No cost center by default - To be defined for each ride',
            defaultAll: 'Define a default cost center for all group users',
            defaultPerUser: 'Define a default cost center by user',
            defaultPerUserHint: "You can define a user cost center in the group's list of users.",
            required: 'Make the cost center mandatory for the reservation',
            actions: {
                add: 'Add a cost center',
                import: 'Import centers',
                export: 'Export the centers',
                default: 'Set default',
            },
            modal: {
                add: 'Add a cost center',
                edit: 'Edit the cost center',
                form: {
                    name: 'Name',
                    description: 'Description',
                    duplicateName: 'This name is already used by another cost center.',
                },
            },
        },
        places: {
            header: 'Geographic parameters',
            headerDescription: 'No parameter applied',
            headerDescriptionActive: '{{number}} active parameter(s)',
            subtitle: 'Facilitate and/or limit reservations for your employees.',
            title: 'Select the settings to apply to your employees',
            description: 'You can choose several possibilities.',
            radiusDesc: 'Rides can only be booked within a radius of the authorized address.',
            areaName: 'Area name',
            options: {
                defaultAddresses: 'Default addresses',
                defaultPerGroup: 'For all group users',
                defaultPickup: 'A default pickup',
                defaultPickupCTA: 'Define a default pickup',
                defaultPickupPerUser: 'Define a default pickup per user',
                defaultPickupPerUserDesc:
                    'You will be able to define the pickup per user in the management of employees associated with the group.',
                defaultPickupDescModal: 'Define a default pickup for each reservation made by a member of this group',
                defaultDropoff: 'A default dropoff',
                defaultDropOffCTA: 'Define a default dropoff',
                defaultDropOffPerUser: 'Define a default dropoff per user',
                defaultDropOffPerUserDesc:
                    'You can define the dropoff per user in the management of employees associated with the group.',
                defaultDropOffDescModal: 'Define a default dropoff for each reservation made by a member of this group',
                favorites: 'Define favorites addresses',
                favorite: 'Define a favorite address',
                setAsWorkAddress: 'Set as the group work address',
                setAsWorkAddressDesc: 'It will show up as "Work" in the app of the group members.',
                workAddressTaken: 'A work address is already defined for this group: it will be replaced by this one.',
                replaceWorkAddress: 'Replace the work address',
                replaceWorkAddressConfirm:
                    '"{{name}}" currently is the group work address. It will be kept as a plain favorite address. Confirm the replacement?',
                favoritesSub: 'Group users will easily find them on their app.',
                noFavorite: 'You have no favorite address',
                addFavorites: 'Add addresses',
                addAreas: 'Add areas',
                areasCount: 'You have {{X}} areas',
                noAreas: 'You have no areas',
                favoritesCount: 'You have {{X}} favorite adress(es)',
                areasSetUp: 'Setting up a ride authorization zone',
                areasSetUpSub:
                    'Group users will only be able to book their pickup location and destination within these geographic areas.',
                areas: 'Setting up an authorization zone',
                areaRadius: 'Radius in KM',
                addressAuthorization: 'Define which point(s) should be in the radius',
                pickupRadius: 'Pickup area',
                dropoffRadius: 'Dropoff area',
            },
        },
        day: {
            header: 'Days and hours',
            headerDescription: 'No applied policy',
            headerDescriptionActive: '{{number}} applied policies',
            subtitle: 'Define when your employees can book their rides.',
            any: 'None',
            limit: 'Personalized days and hours',
            title: 'Define the days and schedules allowed',
            description:
                'Restress the employees of this group to move certain specific days of the week and/or at times of the day.',
            startHour: 'Start time',
            to: 'to',
            endHour: 'End time',
            addHours: 'Add hours',
        },
        limit: {
            header: 'Reservation limits & parameters',
            headerDescription: 'No limit',
            headerDescriptionActive: '{{number}} active parameter(s)',
            subtitle: 'Define precisely the reservation possibilities for your employees.',
            title: 'Define the limits and reservations parameters of your shopping.',
            description: 'You can choose several possibilities.',
            options: {
                bookForColleague: 'Reserve for a colleague',
                bookForColleagueSub: 'A person from the same group.',
                bookForGuest: 'Guest',
                bookForGuestSub: 'Someone outside your organization.',
                reservationLimit: 'Reservations limit',
                reservationLimitHint:
                    'Define the maximum number of rides that an employee can perform in a given period.',
                reservationLimitRideNumber: 'Number of rides',
                spendingLimit: 'Spending limit',
                spendingLimitHint: 'Define the maximum amount that an employee can use in a timely time.',
                noTip: 'Prohibit tips',
                rideReasonMandatory: 'Mandatory ride reason to reserve',
            },
        },
        service: {
            header: 'Authorized ranges',
            headerDescription: 'All authorized ranges',
            headerDescriptionActive: '{{number}} authorized range(s)',
            subtitle: 'Control your spending by only authorizing certain vehicle ranges.',
            service: {
                title: 'What are the authorized services for your employees?',
                description: 'You can choose several services.',
                options: {
                    asap: 'Immediate ride',
                    prebook: 'Prebook',
                    mad: 'Provision',
                    free: 'Free ride',
                },
            },
            gamme: {
                title: 'What ranges can they travel with?',
                description: 'You can choose several ranges.',
                default: 'Define a default range:',
                defaultPlaceholder: 'Default range',
            },
        },
    },
    errors: {
        cbRefuse: 'The addition of your card has been refused. Please try again or use another means of payment.',
        canNotBeEmpty: 'Can not be empty',
        invalidFormat: 'Invalid format',
        paramsIncorrect: 'Incorrect parameters, please try again.',
        defaultError: 'An unknown error occured',
        clientError:
            'An error has occurred! Please accept our apologies for the inconvenience.<br/>We are working to resolve it as quickly as possible. Thank you for your patience.',
        error: 'Something went wrong',
        video: 'Your browser does not support the video tag.',
        offline: 'Please check your internet connection.',
        phoneHomeError:
            'You must enter a mobile phone number in order to receive the tracking SMS of your ride or to call your driver.',
        phoneInvalidError: 'Invalide number, please correct your number.',
    },
    download: {
        ios: 'LeCab for IOS',
        android: 'LeCab for Android',
    },
    common: {
        in: 'In',
        or: 'Or',
        yes: 'Yes',
        no: 'No',
        free: 'Free',
        per: 'Per',
        euro: 'Euro',
        continue: 'Continue',
        loading: 'Loading',
        none: 'No',
        plan: 'Plan',
        optional: '(optional)',
        retry: 'Retry',
        infoRecall: 'You will be reminded of this information during your ride.',
        from: 'From',
        to: 'To',
        at: 'at',
        incoming: 'Incoming',
        inProgress: 'In progress',
        recurrence: 'Recurring',
        gotIt: 'Got it!',
        confirm: 'Confirm',
        validate: 'Validate',
        add: 'Add',
        added: 'Added',
        back: 'Back',
        backToList: 'Back to list',
        prev: 'Previous',
        next: 'Next',
        edit: 'Modify',
        edited: 'Modified',
        warning: 'Warning',
        delete: 'Delete',
        deleted: 'Deleted',
        schedule: 'Schedule',
        deleteHint: 'Are you sure you want to delete: {{details}}?',
        reset: 'Reset',
        search: 'Research',
        searchVerb: 'Research',
        noResult: 'No result',
        perso: 'Personal',
        pro: 'Pro',
        dot: '•',
        rideBetween: 'Rides between',
        displayRidesBetween: 'Display the rides between the dates',
        date: 'Date',
        startDateLabel: 'Starting date',
        endDateLabel: 'Ending date',
        startLabel: 'Start of ride',
        endLabel: 'End of ride',
        number: 'Number',
        group: 'Group',
        ttc: 'All tax included',
        totalHT: 'Total ex-tax',
        tva: 'VAT',
        resetFilter: 'Reset filters',
        clear: 'Clear',
        cancel: 'Cancel',
        cancelRide: 'Cancel the ride',
        cancelled: 'Cancelled',
        save: 'Save',
        saved: 'Saved',
        skip: 'Skip',
        knowMore: 'Learn more',
        more: 'See more',
        see: 'See',
        reduce: 'Reduce',
        all: 'All',
        export: 'Export',
        maintenance: 'Maintenance in progress',
        resendEmail: 'Resend by email',
        downloadPdf: 'Download PDF',
        download: 'Download',
        retryLater: 'An error has occured. Please retry later.',
        numberOnly: '(numbers only)',
        min: 'minimum',
        max: 'maximum',
        char: 'character',
        chars: 'characters',
        details: 'Details',
        driver: 'Driver',
        later: 'Later',
        thanks: 'Thank you',
        yourDriver: 'your driver',
        copy: 'Copy in the clipboard',
        copied: 'Copied in the clipboard',
        copyFailed: 'Copy failed',
        editNotSaved: 'Please note, you have not saved your changes. Are you sure you want to leave?',
        france: 'French Time',
    },
    filter: {
        action: 'Apply',
        filters: 'Filters',
        description: 'Add filters to refine the list of reservations displayed.',
        infoSection: 'Filter by reservation information:',
        periodSection: 'Filter by period:',
        groupSection: 'Filter by group:',
        showCanceledNoCharge: 'Show canceled rides with no charges',
        exportSelection: 'Export the selection',
        exportRealSelection: 'Export real selection',
        errors: {
            noInterval: 'Select a date interval to export',
            before2022: 'You can only export the rides from January 2022',
        },
    },
    time: {
        placeholder: 'dd/mm/yyyy',
        timePlaceholder: 'hh:mm',
        hourFormat: 'HH[h]mm',
        recurrenceFormat: 'DD MMMM yyyy',
        baseFormat: 'ddd DD MMMM',
        completeFormat: 'ddd DD MMM [at] HH:mm[.]',
        lettreFormat: 'ddd DD MMMM [at] HH:mm',
        lettreFormatBold: 'ddd DD MMMM [at] [<b>]HH:mm[</b>]',
        lettreFormatBoldShort: 'ddd DD MMM [at] [<b>]HH:mm[</b>]',
        isoFormat: 'yyyy-MM-DD[T]HH:mm',
        slashFormat: 'DD/MM/yyyy',
        shortFormat: 'DD/MM HH:mm',
        dayFormat: 'dddd',
        h: 'h',
        m: 'm',
        s: 's',
        hour: 'hour',
        hours: 'hours',
        minute: 'minute',
        minutes: 'minutes',
        min: 'min',
        mins: 'mins',
        seconds: 'seconds',
        day: 'Day',
        week: 'Week',
        weekend: 'End of week',
        allDays: 'Every day',
        prefixRecurrence: 'Every',
        month: 'Month',
        year: 'Year',
        mon: 'Monday',
        tue: 'Mardi',
        wed: 'Wednesday',
        thu: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
        sun: 'Sunday',
        now: 'Now',
        to: 'to',
    },
    tripHistory: {
        history: 'History',
        needSomeHelp: 'Get assistance for this ride',
        reportIncident: 'Report an incident',
        bookingTheSame: 'Booking it again',
        noHistory: 'You have no past ride. It is time,',
        noHistoryFilter: 'No ride corresponds to selected filters. Please change the selected filters.',
        noHistoryLink: 'Book a ride!',
        receipt: 'Invoice',
        receiptInProgress: 'Generating invoice',
        recapInProgress: 'Generating summary',
        downloadRecap: 'Download summary',
        downloadReceipt: 'Download invoice',
        canceledWithCharge: 'This ride costs you {{price}} because you cancelled after the time limit.',
        tipsAndRating: {
            how: 'How was your ride?',
            add: 'Add a grade and a tip',
            title: 'Grade your ride',
            booking: `Rided at {{date}} to {{destination}}`,
            thanks: `Thank you for choosing ${company}! We are delighted for transporting you to your destination.`,
            rating: 'How would you grade your ride?',
            ratingThanks: {
                title: 'Thank you for your rating!',
                description: 'Your opinion has been saved.',
            },
            yourRating: 'Your rating',
            yourFeedback: 'Your feedback',
            yourComment: 'Your comment',
            comment: 'Since the quality of our service is essential, your opinion is precious to us!',
            commentPlaceholder: 'Add a comment',
            tip: 'Tip',
            tipAdd: 'Add a tip',
            tipQuestion: 'Would you like to leave a tip to {{driver}}? (optional)',
            tipCustom: 'Add a personalized tip amount',
            tipCustomShort: 'Personalized amount',
            tipCustomPlaceholder: 'Personalized tip',
            tipTitle: 'Leave a tip to {{driver}} (Optional)',
            tipMax: 'Maximum tip: {{amount}}€',
            tipNo: 'Do not leave a tip',
            tipThanks: {
                title: 'Thank you for your tip of {{amount}}',
                description: '{{name}} will be pleased',
                toDriver: 'All of this amount comes back to your driver.',
            },
            soon: 'You can now grade the ride and give a tip to your driver.',
        },
    },
    empty: {
        search: 'No element corresponds to your search. Please change the terms of your search.',
        tripHistory: 'You have not yet completed any ride.',
        inProgress: 'You have no ride in progress.',
        scheduled: 'You have no scheduled ride.',
        recurrence: 'You have no recurring ride.',
        recurrenceInfo: 'A recurring ride is a ride that repeats automatically, for a specified day and time.',
        filter: 'No ride corresponds to selected filters. Please change the selected filters.',
    },
    favorites: {
        favoritesAlternative: 'Favorite',
        favorites: 'Your saved places',
        addFavorite: 'Add new favorite',
        addFavoriteAlternative: 'Add new address',
        addFavoriteAlternativeShort: 'Address',
        addNewName: 'Name',
        addNewAddress: 'Address',
        work: 'Work',
        home: 'Home',
        favorite: 'Favorite',
        defineWorkAddress: 'Define your work address',
        defineWorkAddressShort: 'Work address',
        defineHomeAddress: 'Define your home address',
        defineHomeAddressShort: 'Home address',
        defineFavAddress: 'Define a favorite',
        defineFavAddressShort: 'favorite',
        addSuccess: '{{name}} successfully added',
        editError: "Sorry we couldn't update your favorite. Please try again later",
        addError: "Sorry we coudn't create your favorite. Please try again later",
        deleteError: "Sorry we couldn't delete your favorite; Please try again later",
        deleteFavoriteConfirm: 'Are you sure you want to delete favorite : {{name}} ?',
        cantLocate: 'Address not found?',
        locateOnMap: 'Point it on a card',
        selectOnMap: 'You can add a place by draging the point on the map.',
    },
    family: {
        familyMembers: 'Guests',
        familyHint:
            'Create guests passengers to make them travel with LeCab, without the need to download the application.',
        firstname: 'First name',
        lastname: 'Last name',
        nickname: 'Nickname (optional)',
        phoneNumber: 'Phone number',
        addMember: 'Add guest',
        editMember: 'Edit guest',
        noMember: 'You have no guest yet.',
        maxNumberReached: 'You are limited to 4 family members.',
        confirmDelete: 'Are you sure you want to delete the guest: {{firstname}} {{lastname}}?',
    },
    promo: {
        usePromoCode: 'Use a promo code',
        usePromoCodeDescription: 'Add a code and it will be applied directly to your next personnal ride',
        promoCode: 'Promo code',
        listingTitle: 'Your promo code',
        listingDescription: 'We apply for you the best promo code for your ride.',
        getFreeRide: 'Get free ride',
        promoAdded: 'Promo code added',
        noPromo: 'You do not have an active promo code.',
        expired: 'Expired',
        consumed: 'Already used',
        noLimit: 'Unlimited',
        useLeft: 'remaining use',
        applied: 'Promo code applied {{code}}',
        codeApplied: 'Code applied',
    },
    payment: {
        paymentAdd: 'Add payment option',
        editCardName: 'Edit the name of the card',
        cardName: 'Card name',
        brand: 'Brand',
        num: 'Num',
        status: 'Status',
        expire: 'Expire',
        expired: 'Card expired',
        saving: 'Saving...',
        redirectDoneTitle: 'Processing complete',
        redirectDoneHint: 'You can go back to your payment methods using the arrow at the top left.',
        paymentDefault: 'Default payment method',
        paymentDefaultHint: 'Configure your default payment methods for each of your groups.',
        default: 'Default card',
        noSetting: 'Setting not found for this group',
        onboard: 'Payment on board, you will have to pay on board at the end of your ride directly to your driver',
        centralized: 'Centralized payment, the costs are managed by your company',
        noCard: 'Please add a payment method to be able to order a Cab.',
        errors: {
            defaultCardUpdate:
                'We have failed to define your card as default. Do not panic you can still reserve a ride and try again later.',
            cardDeletion: "Sorry we couldn't delete your card. Try again later.",
            cancelled: 'The operation was cancelled. Try again later.',
            error: 'An error occurred. Try again later.',
            refused: 'The payement has been declined.',
        },
    },
    paymentType: {
        cash: 'Cash',
        paypal: 'Paypal',
        creditCard: 'Credit card',
        applePay: 'Apple pay',
        invoice: 'Invoice',
        onboard: 'On board payment',
        mensual: 'Monthly payment',
        individual: 'Individual payment',
        centralized: 'Centralized payment',
        short: {
            individual: 'Individual Pay.',
            centralized: 'Centralized Pay.',
            onboard: 'On board',
        },
    },
    onboardPayment: {
        title: 'On board payment',
        trackingDescription: 'Once it is over, your ride will have to be paid directly to your driver.',
        description: 'Pay your ride directly to your driver with one of our two on board payment options:',
        contactlessTitle: 'Contactless payment',
        contactlessDescription: 'Your driver will not have access to any of your payment information',
        cashTitle: 'Cash payment',
        terminalTitle: 'Card reader',
        terminalDescription: 'Some of our drivers are equipped with a card payment terminal (TPE)',
        validate: 'Got it',
    },
    paymentClearance: {
        alertTitleOne: 'A ride needs a payment fix',
        alertTitleMany: 'Several rides need a payment fix',
        alertDescriptionOne:
            'The payment method for one of your rides could not be validated. Without a fix, it will be cancelled before departure.',
        alertDescriptionMany:
            'The payment method for {{count}} of your rides could not be validated. Without a fix, they will be cancelled before departure.',
        badge: 'Payment to fix',
        blockedTitle: 'Payment declined',
        blockedDescription:
            'Your payment method could not be validated for this ride. Change it now: validation restarts on its own, with nothing else to do.',
        blockedCta: 'Change payment method',
        cancelledTitle: 'Ride cancelled — payment not validated',
        cancelledDescription: 'This ride was cancelled because its payment method could not be validated in time.',
        cancelledCta: 'Book again',
        close: 'Close',
        // Inline notice on a ride's detail page (LT-1884) — readable without
        // opening anything, once the modal has been dismissed.
        detailsBlocked:
            'Payment declined. Without a valid payment method, this ride will be cancelled two hours before departure.',
        detailsBlockedCta: 'Change payment method',
        detailsCancelled: 'Ride cancelled: its payment method could not be validated in time.',
    },
    status: {
        created: 'Created',
        readyToDispatch: 'Ready to dispatch',
        processing: 'Processing',
        allocated: 'Allocated',
        received: 'Received',
        seen: 'Seen',
        accepted: 'Accepted',
        onWay: 'On way',
        atPickup: 'At pickup',
        passengerOnBoard: 'Passenger on board',
        dropIn5: 'Drop in 5',
        atDropOff: 'At drop off',
        finished: 'Finished',
        cancelled: 'Cancelled',
        cancellationNoCharge: 'Cancellation no charge',
        cancellationWithCharge: 'Cancellation with charge',
    },
    table: {
        groups: 'Groups',
        admin: 'Administrator',
        members: 'Members',
        actions: 'Actions',
        dateAdded: 'Date added',
    },
    importBulk: {
        uploadStep: {
            title: 'Upload file',
            manifestTitle: '',
            manifestDescription:
                'Add multiple collaborators to this group simultaneously by importing a spreadsheet. To get started, upload your file containing the information shown below. You can later modify their roles within this group.',
            manifestDescriptionInvite:
                'Add multiple collaborators to this group simultaneously by importing a spreadsheet. To get started, upload your file containing the information shown below. An invitation to join this group will be sent to them by email. You can later modify their roles within this group.',
            maxRecordsExceeded: 'Too many records. Up to {{X}} allowed',
            dropzone: {
                title: 'Upload .xlsx, .xls or .csv file',
                errorToastDescription: 'Upload rejected',
                activeDropzoneTitle: 'Drop file here...',
                buttonTitle: 'Select file',
                loadingTitle: 'Processing...',
            },
            selectSheet: {
                title: 'Select the sheet to use',
                nextButtonTitle: 'Next',
            },
        },
        selectHeaderStep: {
            title: 'Select header row',
            nextButtonTitle: 'Next',
        },
        matchColumnsStep: {
            title: 'Match Columns',
            nextButtonTitle: 'Next',
            userTableTitle: 'Your table',
            templateTitle: 'Will become',
            selectPlaceholder: 'Select column...',
            ignoredColumnText: 'Column ignored',
            subSelectPlaceholder: 'Select...',
            matchDropdownTitle: 'Match',
            unmatched: 'Unmatched',
            duplicateColumnWarningTitle: 'Another column unselected',
            duplicateColumnWarningDescription: 'Columns cannot duplicate',
        },
        validation: {
            emailInvalid: '',
            emailMissing: '',
            firstnameMissing: '',
            lastnameMissing: '',
        },
        validationStep: {
            title: 'Validate data',
            nextButtonTitle: 'Confirm',
            noRowsMessage: 'No data found',
            noRowsMessageWhenFiltered: 'No data containing errors',
            discardButtonTitle: 'Discard selected rows',
            filterSwitchTitle: 'Show only rows with errors',
        },
        alerts: {
            confirmClose: {
                headerTitle: 'Exit import flow',
                bodyText: 'Are you sure? Your current information will not be saved.',
                cancelButtonTitle: 'Cancel',
                exitButtonTitle: 'Exit flow',
            },
            submitIncomplete: {
                headerTitle: 'Errors detected',
                bodyText:
                    'There are still some rows that contain errors. Rows with errors will be ignored when submitting.',
                bodyTextSubmitForbidden: 'There are still some rows containing errors.',
                cancelButtonTitle: 'Cancel',
                finishButtonTitle: 'Submit',
            },
            unmatchedRequiredFields: {
                headerTitle: 'Not all columns matched',
                bodyText: 'There are required columns that are not matched or ignored. Do you want to continue?',
                listTitle: 'Columns not matched:',
                cancelButtonTitle: 'Cancel',
                continueButtonTitle: 'Continue',
            },
            toast: {
                error: 'Error',
            },
        },
    },
    selfService: {
        common: {
            free: 'Free',
            perMonth: 'per month',
            upTo: 'Up to',
            maxUser: 'Max user',
            maxUsers: 'Max user(s)',
            select: 'Select plan',
            custom: 'By conditions',
            nbUsers: 'Number of users',
            unlimited: 'UNLIMITED',
            benefits: {
                title: 'Benefits',
                policies: 'Integrated travel policy',
                budget: 'Budget control',
                premium: 'Premium quality',
                reservation: 'Simplified reservation process',
                vip: 'Priority customer status',
                infinity: 'Infinity class',
                colleagues: 'Book for employees',
                guests: 'Book for a guest',
                costCenters: 'Cost centers',
                billingCostCenters: 'Cost center billing',
                sales: 'Dedicated interlocutor',
                a: 'Book your ride in advance',
                b: 'Fixed price at airports',
                c: 'Invoicing on behalf of the company',
                cbis: 'Centralized invoicing on behalf of the company',
                d: 'Priority status',
                e: 'Limited to 1 users',
                ebis: 'Limited to 5 users',
                eter: 'Book for 20 free guests (*)',
                equa: 'Unlimited users and guests',
                f: 'Geographic restrictions and timetables',
                g: 'Dedicated interlocutor',
            },
            hints: {
                policies1: 'Optimized approval workflow',
                policies2: 'Support for your CSR procedures',
                policies3: 'Guaranteed security and confidentiality',
                budget1: 'Instant invoicing',
                budget2: 'Fixed rate upon booking',
                vip1: 'Reservation in priority mode',
                vip2: 'The best drivers',
                colleagues: "Pass the reservations of your group's colleagues",
                guests: 'Create reservations for your guests (up to 20 by month*)',
                guestsPricing: '*Additional users will be billed-€/users and guests at-€/guests',
                costCenters: 'Combine cost center with your reservations',
                billingCostCenters: 'Limit movement to geographic areas or time slots',
            },
        },
        formula: {
            title: 'Our formulas',
            description: 'Choose the offer corresponding to your mobility needs',
            additional: '*Additional users will be charged € {{userPrice}}/users and guests at € {{guestPrice}}/guests',
            modify: 'Change formula',
            modifyDesc: 'Warning! Some advantages of the chosen formula may no longer be available in your new choice.',
        },
        policies: {
            title: 'Travel policies',
            description:
                'Choose travel policies to apply to your first group in order to personalize the booking and travel experience of your employees.',
        },
        payment: {
            title: 'Add your payment method',
            descFirstPart:
                'It will be used for the payment of your rides and your subscription according to the chosen formula.',
            descSecondPart:
                'To verify your information, a request for a temporary levy is made. It is immediately canceled and its amount is not billed.',
        },
        settings: {
            title: 'Configure your payment',
            description: 'Define your business payment policy. You can change it later in your administrator menu.',
            policy: {
                title: 'Payment policy',
                individual: 'Individual payment in the ride',
                individualHint:
                    'Your employees will have to set their reservations with the bank card added to their personal profile and defined as a professional payment.',
                central: 'Centralized payment in the ride',
                centralHint:
                    'The reservations of your employees will be set with the bank card defined in the previous step.',
                nbParams: 'active parameter(s)',
            },
        },
        company: {
            title: 'Information on the company',
            description: 'This information is necessary to create your company',
            name: 'Company Name',
        },
        account: {
            title: 'Your account',
            description: 'This information is necessary to finalize your LeCab account',
            name: 'Account name',
        },
        signContract: {
            title: 'Contract signature',
            description: 'Your signed contract will be sent to you by email in PDF format.',
            cgu: 'The Customer declares that they have read the general conditions of use of the service available on the site <a href="https://www.lecab.fr">www.lecab.fr</a> and the specific conditions opposite.',
            sign: 'Sign',
        },
        welcome: {
            title: 'Easy start',
            creating: 'Creating your personal workspace...',
            videoTuto: 'See the video tutorials',
            invite: {
                radio: 'Invite your employees',
                description:
                    'You can easily invite one or more employees to join your business account in order to benefit from the travel policies that you will define.',
            },
            policy: {
                radio: 'Change travel policies',
                description:
                    'You can modify the travel policies of each of your groups at any time, they will then be applied to each of your group employees.',
            },
        },
        layout: {
            stepZeroTitle: 'Your Offer',
            stepOneTitle: 'Your account',
            stepTwoTitle: 'Your travel policies',
            stepThreeTitle: 'Your payment methods',
            stepFourTitle: 'Your contract',
            stepZeroTitleMobile: 'Offer',
            stepOneTitleMobile: 'Account',
            stepTwoTitleMobile: 'Travel policies',
            stepThreeTitleMobile: 'Payment',
            stepFourTitleMobile: 'Contract',
        },
        shared: {
            skipStep: 'Define later?',
            skipStepAction: 'Skip this step.',
            needHelp: 'Need help?',
            needHelpAction: 'Be called',
        },
    },
    faq: {
        action: 'Send',
        actionChange: 'Change',
        description:
            'For any problem on one of your reservation, we invite you to follow the link "Get help for this ride" from your',
        history: 'history.',
        message: 'Add a comment',
        booking_answer: 'In order to select the specific ride, please use the following link',
        link_booking: 'My bookings',
        rdv_title: 'Any questions? Our team is here to support you.',
        rdv_details:
            'Should you need help or information, please feel free to <b>book an online slot</b> with our team.\nEach appointment can take up to 15 minutes.',
        rdv_action: 'Book an appointment',
        files: {
            max: 'Maximum 1 file, max 10 MB.',
            format_allowed: 'Authorized format : .jpg, .jpeg, .png, .gif, .pdf.',
            noFile: 'No file detected. Please select a file.',
            tooHeavy: 'The file is over 10 Mb. Please select a lower size file.',
            tooHeavyResized: 'After compression the file is still too heavy. Please select a lower size file.',
        },
        metas: {
            ride_reference: 'Ride number',
            invoice_reference: 'Bill number',
            forgotten_object: 'Forgotten object',
            event_name: 'Event name',
            phone_number: 'Phone number',
            company_name: 'Company name',
            week_number: 'Week number',
            partner_reference: 'Partner ID',
            manager_reference: 'Manager ID',
            driver_reference: 'Driver ID',
            vehicle_reference: 'Vehicle ID',
        },
        actions: {
            confirm: {
                title: 'Request sent!',
                message: 'Request sent! We will get back to you as soon as possible.',
                ok: 'Ok',
            },
        },
    },
    accessibility: {
        toggle: {
            changeToPro: 'Change to the profesional account',
            changeToPerso: 'Change to the personal account',
        },
        invertPuDo: 'Exchange pick-up and drop-off',
        hidden: 'hidden element',
        expand: 'expand',
    },
    jo: {
        asap: 'For any immediate ride request, please contact the following number: +33 9 86 86 07 16',
        schedule: 'For any ride request for tomorrow please contact the following number: +33 9 86 86 07 16',
    },
    external: {
        popup: {
            title: 'Marcel becomes LeCab',
            details: 'You are currently using the “Marcel by LeCab” transition application.',
            info: {
                b2b: {
                    title: '8 € offered on your next LeCab ride',
                    details:
                        'Available on the official LeCab application.The reduction will be automatically added to your account.',
                },
                b2c: {
                    title: 'Download the app LeCab',
                    details:
                        'You are currently using the “Marcel by LeCab” transition application. Download the official LeCab application now.',
                },
            },
            download: 'Download LeCab',
        },
    },
    wicked: {
        title: 'All roads lead to the magician with LeCab!',
        description:
            "On the occasion of Wicked Part II's cinema release, magic invites itself to LeCab! But rest assured, our drivers will not throw you out ...",
        bulletGreenTitle: 'The Green range becomes the Green Wicked II range',
        bulletGreenDescription: 'Its CO2 emission is still so low',
        bulletCoverTitle: 'Flocked cars',
        bulletCoverDescription: 'If you are lucky, you may come across a car in the colors of Wicked Part II',
        validate: 'Got it!',
    },
    onboarding: {
        step1: {
            title: 'Welcome to LeCab!',
            action: 'Thank you!',
        },
        step2: {
            title: 'Add a bank card',
            info: 'A request will be sent to your bank, but no debit will be made.',
            action: 'Add',
        },
        step3: {
            title: 'Activate your geolocation',
            info: 'Activating your geolocation will allow you to book rides more easily. LeCab does not keep any backup of your trips.',
            action: 'Activate my geolocation',
        },
        step4: {
            title: 'Activate the notifications',
            info: 'Activating notifications will allow you to receive your shopping information.',
            action: 'Activate the notifications',
        },
        step5: {
            title: 'Order your first ride',
            action: "Let's go!",
        },
    },
};
